import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function animateStatsSection(section, textLines, blocks) {

  // Individual tweens 
  // Animated Lines of Text 
  let textLinesTween = textLines ? gsap.to(textLines, {
    duration: 0.8,
    y: 0,
    opacity: 1,
    stagger: {
      each: 0.25,
      ease: "none",
      from: "start",
    },
  }) : null;

  // Animated blocks 
  let blocksTween = blocks ? gsap.to(blocks, {
    duration: 0.4,
    x: 0,
    opacity: 1,
    stagger: {
      each: 0.5,
      ease: "none",
      from: "start",
    },
  }) : null;

  // Timeline 
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
    },
  });

  tl
    .add(textLinesTween)
    .add(blocksTween);

}